import {FilterOption, FilterType, OffersFilter} from './offers-filter.model';
import {FieldConfig} from '../../../../../models/field-config';
import {FieldType} from '../../../../../models/field-type';
import {FormConfig} from '../../../../../models/form-config';
import {Validator} from '../../../../../models/validator.enum';
import {GA4EventKey} from '../../../../../../core/consts/ga4-event-key.enum';

export class OffersFilterConfig {

    private filter: OffersFilter;

    constructor(filter: OffersFilter) {
        this.filter = filter;
    }

    createFormConfig(): FormConfig {
        const fieldsConfig: FieldConfig[] = [];
        if (this.filter.options) {
            if (this.filter.type === FilterType.RADIO) {
                fieldsConfig.push(this.createRadioConfig(this.filter));
            } else if (this.filter.type === FilterType.CHECKBOX) {
                this.filter.options.forEach(option => fieldsConfig.push(this.createCheckboxConfig(option)));
            }
        }

        return {
            formKey: this.filter.key,
            fieldsConfig: fieldsConfig
        };
    }

    private createRadioConfig(filter: OffersFilter): FieldConfig {
        const radioConfigs = filter.options.map(option => ({
           value: option.key,
           label: option.label
        }));

        return {
            fieldKey: filter.key,
            type: FieldType.Radio,
            validators: [Validator.REQUIRED],
            radioConfig: radioConfigs
        };
    }

    private createCheckboxConfig(option: FilterOption): FieldConfig {
        const config: FieldConfig = {
            fieldKey: option.key,
            type: FieldType.Checkbox,
            caption: option.label,
            validators: [],
            checkboxConfig: {
                readonly: false,
                clickableLabel: true,
                translateLabel: option.translate
            },
            analyticsConfig: {
                eventsToSkip: [GA4EventKey.FIELD_CLICK]
            }
        };
        if (option.selectedAndDisabled) {
            config.checkboxConfig['disableVisualChangesOnDisabled'] = true;
        }
        if (option.tooltip) {
            config.description = option.tooltip;
            config.tooltipIconOutlined = true;
            config.tooltipTheme = 'left-align';
        }
        return config;
    }

}
